angular.module('userSettingsMod')

.controller('automationsCtrl', ['$scope', 'cnfg', 'localizationService', async ($scope, cnfg, localizationService) => {
	const dictionary = localizationService.getDictionary('account_settings');
	const translate = (word) => localizationService.translate(word, dictionary);
	$scope.translate = translate;

	$scope.tabs = [
		{
			name: translate('Task')
		},
		{
			name: translate('Trigger')
		},
		{
			name: translate('Api')
		},
		{
			name: translate('Elements')
		}
	];

	$scope.mobileTabDetailOpen = false;
	$scope.switchTab = (index) => {
		$scope.currentTab = index;
		$scope.mobileTabDetailOpen = true;
		$scope.nav.title = $scope.tabs[index].name;
		$scope.nav.onBack = () => {
			$scope.mobileTabDetailOpen = false;
			$scope.nav.onBack = null;
			$scope.nav.title = null;
		};
	}

	$scope.appsList = await gudhub.getAppsList();
	const defaultAppId = gudhub.storage.user.app_init;
	$scope.appsList = $scope.appsList.filter(app => {
		return (app.permission == 2 || app.permission == 3 || app.permission == 4) && app.app_id != defaultAppId;
	});
	$scope.clonedAppsList = JSON.parse(JSON.stringify($scope.appsList));
	$scope.$apply();

	const appsForGetApi = {
		apps: []
	}

	$scope.clonedAppsList.forEach(app => {
		appsForGetApi.apps.push(String(app.app_id));
	});

	$scope.taskList = await gudhub.req.axiosRequest(
		{
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(appsForGetApi),
			url: cnfg.node_services_api_path + '/tasks/get-tasks-list'
		});

	$scope.currentTab = 3;

	$scope.appsWithApi = await gudhub.req.axiosRequest(
		{
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(appsForGetApi),
			url: cnfg.node_services_api_path + '/api/get-api-list'
		});

	$scope.triggerList = await gudhub.req.axiosRequest(
		{
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(appsForGetApi),
			url: cnfg.node_services_api_path + '/trigger/get-trigger-list'
		});

}]);
